export const ROOT_CAUSE_CATEGORY_READ_LIMIT = 9999;

export const ISSUE_ROOT_CAUSES_PERMITTED_ACTIONS = {
  CAN_EDIT: 'edit',
  CAN_DELETE: 'delete',
  CAN_CHANGE_ORDER: 'change_order'
};

export const ISSUE_ROOT_CAUSES_ATTRIBUTES = {
  TITLE: 'title',
  STATUS: 'isActive'
};

export const ISSUE_ROOT_CAUSES_TABLE_COLUMN_KEYS = {
  ACTION: 'action',
  TITLE: 'title',
  STATUS: 'status'
};

export const ISSUE_ROOT_CAUSES_STATUS_TYPES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

export const ISSUE_ROOT_CAUSE_API_ERROR_TYPES = {
  ROOT_CAUSE_USED_CONFLICT: 'ROOT_CAUSE_USED_CONFLICT'
};
